module.exports = __webpack_public_path__ + "media/site_templates/www.pianomovingservice.com.au/images/splash-2bcb0aac861fd4acb398301f2bf7e1f1.jpg";